import React from 'react';
import { useTranslation } from 'react-i18next';
import BasicForm from '../basicForm/basicForm';
import style from './errorForm.module.scss';

function ErrorForm(props) {
  const { error, cancel, backHandle } = props;
  const { t } = useTranslation();
  return (
    <BasicForm cancel={cancel}>
      <div className={style.head_wrapper}>
        <h3 className={style.header}>{t('common.errors.oops')}</h3>
        <h4 className={style.sub_header}>
          {t('common.errors.message')}: {error}
        </h4>
      </div>
      <button disabled className={style.back_button} onClick={backHandle}>
        {t('common.general.back')}
      </button>
    </BasicForm>
  );
}

export default ErrorForm;
